import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../its/services/authentication.service';
import { LayoutService } from './service/app.layout.service';
import { User } from '../its/models/user';
import { AuthorityService } from '../its/services/authority.service';
import { Router } from '@angular/router';
import { PdfDownloadService } from '../its/services/pdfdownload.service';
import * as saveAs from 'file-saver';
import { UserService } from '../its/services/user.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { UserJsonDTO } from '../its/models/userJsonDTO';
import { MessageService } from 'primeng/api';
import * as FileSaver from 'file-saver';
import { DateTimeHelper } from '../its/helpers/date-time.helper';

@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html',
    providers: [MessageService]
})
export class AppProfileSidebarComponent implements OnInit{

  userlogged:User;
  objResponse: UserJsonDTO = new UserJsonDTO();
  deleteUserDialog: boolean = false;
    
    
    constructor( public layoutService: LayoutService, 
                 private pdfDownloadService: PdfDownloadService,
                 public authenticationService: AuthenticationService,
                 private authorityService: AuthorityService,
                 private userService: UserService,
                 private messageService: MessageService,
                 private router: Router) {

    }
    ngOnInit(): void {
        this.userlogged = this.authenticationService.getUserValue;
    }

    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }

    changeOut(){
        this.authorityService.setEnteUO(null);
        localStorage.removeItem('currentUO');
        this.router.navigate(['selection']);

    }

    getUserManual(){
        this.pdfDownloadService.downloadManual().subscribe({
            next: (data: Blob) => {
                const downloadUrl = window.URL.createObjectURL(data);
                saveAs(downloadUrl, 'manuale-utente.pdf');
                this.messageService.add({ severity: 'success', summary: 'Operazione avvenuta con successo.', detail: 'Download completato.', life: 3000 });
                setTimeout(() => { this.visible = false; }, 3000); 
            //Questo simula un collegamento ed il click per il download
            // const downloadUrl = window.URL.createObjectURL(data);
            // const link = document.createElement('a');
            // link.href = downloadUrl;
            // link.download = 'manuale-utente.pdf';  // Nome del file scaricato
            // link.click();
          },
          error: (error) => {
            this.messageService.add({severity:'error', summary:'Operazione non riuscita.', detail:'Download del file non riuscito.', life: 3000});
            setTimeout(() => { this.visible = false; }, 3000);
          }
        });
    }



    private setting = {
        element: {
          dynamicDownload: null as unknown as HTMLElement
        }
      }

    dynamicDownloadJson() {
        this.authenticationService.getById(this.userlogged.id!).subscribe({
          next: (response) => {               
            let objU: User = response;                       
            this.objResponse.email = objU.email;
            this.objResponse.firstName = objU.firstName;
            this.objResponse.lastName = objU.lastName;
            this.objResponse.userName = objU.userName;
            this.objResponse.taxId = objU.taxId;
            this.objResponse.roles = objU.roles.map(role => role.name);  
          
            // this.dyanmicDownloadByHtmlTag({
            // fileName: 'My_Report.json',
            // text: JSON.stringify(this.objResponse)
            // });                  
            const jsonString = JSON.stringify(this.objResponse);
            const blob = new Blob([jsonString], { type: 'application/json' });
            FileSaver.saveAs(blob, 'MyReport' + DateTimeHelper.getCleanedIsoTimestamp() + ".json");
            this.messageService.add({ severity: 'success', summary: 'Operazione avvenuta con successo.', detail: 'Download completato.', life: 3000 });
            setTimeout(() => { this.visible = false; }, 3000); 
          },
          error: (error) => {
            this.messageService.add({severity:'error', summary:'Operazione non riuscita.', detail:'Download del file non riuscito.', life: 3000});
            setTimeout(() => { this.visible = false; }, 3000); 
          }
      });
    }
  
        //Metodo per creare un link e simulare il click, in modalità nascosta
        private dyanmicDownloadByHtmlTag(arg: {
          fileName: string,
          text: string
        }) {
          if (!this.setting.element.dynamicDownload) {
            this.setting.element.dynamicDownload = document.createElement('a');
          }
          const element = this.setting.element.dynamicDownload;
          const fileType = arg.fileName.indexOf('.json') > -1 ? 'text/json' : 'text/plain';
          element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(arg.text)}`);
          element.setAttribute('download', arg.fileName);
      
          var event = new MouseEvent("click");
          element.dispatchEvent(event);
        }
  
      // downloadProfile(){
      //     console.log(this.resJsonResponse);
      //     var theJSON = JSON.stringify(this.resJsonResponse);
      //     var uri = this.sanitizer.bypassSecurityTrustUrl("data:text/json;charset=UTF-8," + encodeURIComponent(theJSON));
      //     this.downloadJsonHref = uri;
      //     //this.authenticationService.downloadProfile();
      // }
  
      deleteProfile(){
          this.deleteUserDialog = true;        
      }
  
      confirmDelete() {
          this.deleteUserDialog = false;
          this.authenticationService.deleteProfile(this.authenticationService.getUserValue?.email!).subscribe({
              next: (response : any) => {               
                  this.messageService.add({ severity: 'success', summary: 'Eseguito', detail: 'Utente eliminato', life: 3000 }); 
                  localStorage.clear();
                  setTimeout(() => {
                    this.visible = false;
                    this.router.navigate(['authentication/login']);             
                  }, 3000);  // Ritardo di 3000 millisecondi (3 secondi)
                  
              },
              error: ((error) => {
                this.messageService.add({severity:'error', summary:'Non eseguito', detail:'Operazione non riuscita.', life: 3000});
                setTimeout(() => {
                  this.visible = false;    
                }, 3000);  // Ritardo di 3000 millisecondi (3 secondi)
              })
          });
      }
      
    changePassword(){
      this.visible = false;
      this.router.navigate(['authentication/changepassword']);
    }

    signOut(){
        this.authenticationService.logout();
    }
}